import styled from '@emotion/styled';
export const OverViewSpan = styled.span({
    fontWeight: '700',
    paddingRight: '20px',
    display: 'block'
});
export const OverviewDiv = styled.div({
    padding: '5px'
});
